// extracted by mini-css-extract-plugin
export var dot = "_qm-2";
export var wave = "_qm-0";
export var waveSmall = "_qm-1";